import React, { useContext, useEffect, useState, createContext } from "react";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../../AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
export const FarmerContext = createContext()
const FarmerProvider = ({ children }) => {
  // Token in which a user has
  const { token } = useContext(AuthContext)
  // State to be able to change the username
  // const [username, setUserName] = useState("")  
  // const [name,setName]=useState("")
  // const [id,setId]=useState(0)
  // const [email,setEmail]=useState("")
  // // Variable to be able to get th role and see whether a user is autorized to view this dashboard
  // const [role, setRole] = useState("")
  // const [profile, setProfile] = useState("")
  const [farmersData,setFarmersData]=useState({
    name:"",
    email:"",
    profile:"",
    id:0,
    username:'',
    role:''
  })
  // Varable to hold all the data for  a given user
  const [data, setData] = useState([])
  // Variable to hold the banks that a user does not have
  const [availableBanks, setAvailableBanks] = useState([])
  // Variable to hold the hotels that a user does not have
  const [availableHotels, setAvailableHotels] = useState([])
  // Variable to hold the customers that a user does not have
  const [availableCustomers, setAvailableCustomers] = useState([])
  //  Variable to hold the farmer,s trans that a farmer does not have
  const [availableTransporters, setAvailableTransporters] = useState([])
  //  Varibale to holdthe farmer's transporters
  const [farmerTransporterData, setFarmerTransporterData] = useState([])
  // Variable to determine whether the useFormik is in add or delete mode
  const [relToDel, setRelToDel] = useState(false)
  // Variable to hold the owners of the bank that the farmer has
  const [farmerBankOwners, setFarmerBankOwners] = useState([])
  // Variable to hold the owners of the hotel that the farmer has
  const [farmerHotelOwners, setFarmerHotelOwners] = useState([])
  // Variable to hold the owners of the bank that the customer has
  const [farmerTransOwners, setFarmerTransOwners] = useState([])
  // State to hold  the customers of the farmer
  const [farmerCustomers, setFarmerCustomers] = useState([])
  const navigate = useNavigate()
  //  State to hold the banks that a farmer has
  const [farmerBanks, setFarmerBanks] = useState([])
  //  State to hold the Hotels that a farmer has
  const [farmerHotels, setFarmerHotels] = useState([])
//  State to hold the admins for communication
const [admins, setAdmins] = useState([])
  // The url where we will be doing operations
  const baseUrl = process.env.REACT_APP_SECOND_BACKEND_URL;
  
  useEffect(() => {
    if (token) {
      // Decode the token to get the decoded token whith different data      
      const decodedToken = jwtDecode(token)
      const {name,username,email,id,role,profile}=decodedToken?.sub           
      if (role !== "farmer") {
        navigate("/unauthorized")
      }
      fetchFarmerInfo(id)
      setFarmersData((prevValues)=>({
        ...prevValues,
        name:name?name:prevValues?.name,
        username:username?username:prevValues?.username,
        email:email?email:prevValues?.email,
        id:id?id:prevValues?.id,
        profile:profile?profile:prevValues?.profile,
        role:role?role:prevValues?.role,
      }))      

    }
    else{
      navigate("/loginUser")
    }
  }, [token])
  //  Useeffect to fetch the admins
  useEffect(() => {
    fetchAdmins()
  }, [])


  const fetchAdmins = async () => {
    try {
      const res = await fetch(`${baseUrl}/admins`)
      let adminsData = await res.json()
      setAdmins(adminsData)
    } catch (error) {
      console.error(`Error fetching admins ,${error}`)
    }

  }
  // useEffect(() => {
  //   if (data.length > 0) {
  //     axios.get(`${baseUrl}/hotels`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     }).then(res => {
  //       const hotelsData = res?.data
  //       if (data[0]?.Hotels?.length>0) {
  //         const farmerHotelName = data[0]?.Hotels.map((hotel) => hotel.id)
  //         setAvailableHotels(hotelsData.filter(hotel => !farmerHotelName.includes(hotel.id)))
  //       }
  //       else {
  //         setAvailableHotels(hotelsData)
  //       }

  //     }).catch(error => {
  //       console.error("An error occured", error)
  //     })

  //     axios.get(`${baseUrl}/banks`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     }).then(res => {
  //       const banksData = res.data
  //       if (data[0]?.Banks?.length>0) {
  //         const farmerBanksName = data[0].Banks.map((bank) => bank.id)
  //         setAvailableBanks(banksData.filter(bank => !farmerBanksName.includes(bank.id)))
  //       }
  //       else {
  //         setAvailableBanks(banksData)
  //       }
  //     }).catch(error => {
  //       console.error("An error occured", error)
  //     })

  //     axios.get(`${baseUrl}/customers`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     }).then(res => {
  //       const customersData = res.data
  //       if (data[0]?.Customers?.length>0) {
  //         const farmerCustomerNames = data[0].Customers.map((customer) => customer.id)
  //         setAvailableCustomers(customersData.filter(customer => !farmerCustomerNames.includes(customer.id)))
  //       }
  //       else {
  //         setAvailableCustomers(customersData)
  //       }

  //     }).catch(error => {
  //       console.error("An error occured", error)
  //     })
  //     axios.get(`${baseUrl}/transporters`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     }).then((res) => {
  //       let transData = res.data
  //       // console.log(transData)
  //       if (data[0]?.Transporters?.length > 0) {

  //         let transDataIds = data[0]?.Transporters?.map((trans) => trans.id)
  //         let filteredTransporters = transData.filter((trans) => !transDataIds.includes(trans.id))
  //         setAvailableTransporters(filteredTransporters)
  //       }
  //       else {
  //         setAvailableTransporters(transData)
  //       }
  //     })
  //   }
  // }, [data])

  useEffect(() => {
    if (farmersData?.username) {
      formik.setFieldValue("farmer_username", farmersData?.username)
    }
  }, [farmersData?.username])

  // Fuction to handlefetching farmer data 
  const fetchFarmerInfo = (id) => {
    axios.get(`${baseUrl}/farmers/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then (
      response => {
      const allData = response.data
      setData(allData)   
      const allCustomers=allData[0]?.AllCustomers;      
      if (allData[0]?.Customers.length>0) {
        setFarmerCustomers(allData[0].Customers)       
      }
      else{
        if(allCustomers.length>0){
          const allFarmerCustomersId=allData[0]?.Customers.map(customer=>customer.id);
          const filteredCustomers=data[0]?.allCustomers.filter(customer=>!allFarmerCustomersId.includes(customer.id))
        setAvailableCustomers(filteredCustomers);       }
      }
      if (allData[0]?.Banks.length>0) {
        const allBanks=allData[0]?.Banks;
        const farmerBankIds=data[0].Banks.map(bank=>bank.id);
        if(farmerBankIds.length>0){
         const NewlyfilteredBanks=allBanks.filter(bank=>!farmerBankIds.includes(bank.id));
         setAvailableBanks(NewlyfilteredBanks);
        // filter out the banks to ensue we get only the banks that a  farmr does not have 
        // setFarmerBanks(allData[0].Banks);
        const newBankOwners = allData[0].Banks.flatMap(bank => bank.owners)
        if(newBankOwners.length>0){
          const uniqueBankOwners = [...new Set(newBankOwners.map(bo => bo.username))].map(username => newBankOwners.find(bo => bo.username === username))
        setFarmerBankOwners(uniqueBankOwners)

        }
      }
      if (allData[0]?.Hotels?.length>0) {
        if (allData[0]?.AllHotels?.length>0){
          const hotelOwnerHotelIds=data[0]?.Hotels.map(hotel=>hotel.id);
          const filteredHotels=allData[0]?.AllHotels.filter(hotel=>!hotelOwnerHotelIds.includes(hotel.id))
          setAvailableHotels(filteredHotels);
        }
        setFarmerHotels(allData[0].Hotels)        
        const newHotelOwners = allData[0].Hotels.flatMap(hotel => hotel.owners)
       if(newHotelOwners.length>0){
        const uniqueHotelOwners = [...new Set(newHotelOwners.map(ho => ho.username))].map(username => newHotelOwners.find(ho => ho.username === username))
        setFarmerHotelOwners(uniqueHotelOwners)
       }
      };
      if (allData[0]?.Transporters?.length > 0) {
        setFarmerTransporterData(allData[0].Transporters)
        const newTransOwners = allData[0].Transporters.flatMap(trans => trans.owners);
        if(newTransOwners.lengtj){
          const uniqueTransOwners = [...new Set(newTransOwners.map(trans => trans.username))].map(username => newTransOwners.find(trans => trans.username === username))
          setFarmerTransOwners(uniqueTransOwners)
        }
      }

    }})
      .catch(error => {
        console.error("Error fetching farmer data ", error)
      })
  }
  // console.log(availableTransporters)
  useEffect(() => {
    if (farmersData?.profile) {
      fetchProfile()
    }

  }, [farmersData?.username])
  const fetchProfile = async () => {
    try {
      const res = await fetch(`${baseUrl}/uploads/${farmersData?.username}_profile_picture.png`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (res.ok) {
        let blob = await res.blob()
        let url = URL.createObjectURL(blob)
        setFarmersData((prevValues)=>({
          ...prevValues,
          profile:url
        }))
      }
      else{
        setFarmersData((prevValues)=>({
          ...prevValues,
          profile:null

        }))
      }
    } catch (error) {
      console.error(`An error occurred fetching profiles`, error)
    }

  }
  // console.log(profile)
  const requestAddRelationship = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/login/admin/farmers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(values)
      })
      if (res.ok) {
        alert(`${values.name} added successfuly`)
        fetchFarmerInfo(farmersData?.id)
      }
      else {
       if(res.status===500){
        alert("An error occurred ,please try again")
       }
       else{
        const errMessage=await res.json()
        alert(`An error ocurred adiing ${values.name}: ${errMessage.Error || errMessage.Message}`)
       }
      }
    } catch (error) {
      console.error("An error occured", error)
    }
  }

  const requestDelRel = async (values) => {
    try {
      if (!window.confirm(`Are you sure you want to delete ${values.name}`)) return;
      else {
        const res = await fetch(`${baseUrl}/login/admin/farmers`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(values)
        })
        if (res.ok) {
          alert(`${values.name} deleted successfuly`)
          fetchFarmerInfo(farmersData?.id)
        }
        else {
          if(res.status===500){
           alert(`An error occurred deleting ${values?.name} , please try again`)
          }
          else{
            const errMessage=await res.json()
            alert(`An error occurred deleting ${values?.name}: ${errMessage.Error || errMessage.Message}`)

          }
        }
      }
    }
    catch (error) {
      console.error("An error occured", error)
    }
  }

  const handleSendMessage = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/messages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(values)
      })
      if (res.ok) {       
       
      }
      else {
        alert("An error ocuurred")
        console.error("An error occurred sending message", res.statusText)
      }
    } catch (error) {
      console.error("An error occurred sending message", error)
    }
  }

  const formik = useFormik({
    initialValues: {
      farmer_username: farmersData?.username,
      name: ""
    },
    validationSchema: yup.object().shape({
      farmer_username: yup.string().required("farmer_username is required").typeError("farmer_username should be a string"),
      name: yup.string("Name should be a string").typeError("Name should be a string").required("Name is required")
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (relToDel) {
          await requestDelRel(values)
          setRelToDel(false)
        }
        else {
          await requestAddRelationship(values)
          setRelToDel(false)
        }
      }
      catch (error) {
        console.error("An error occured", error)
      }
      finally {
        setSubmitting(false)
      }
    }
  })
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [postsPerPage, setPostPerPage] = useState(4)
  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const paginate = (num) => {
    setCurrentPage(num)
  }
  // console.log(farmerBanks)
  // Pagination
  const newBanksData = farmerBanks.length > 4 ? farmerBanks.slice(indexOfFirstPost, indexOfLastPost) : farmerBanks
  const newHotelsData = farmerHotels.length > 4 ? farmerHotels.slice(indexOfFirstPost, indexOfLastPost) : farmerHotels
  const newTransportersData = farmerTransporterData.length > 4 ? farmerTransporterData.slice(indexOfFirstPost, indexOfLastPost) : farmerTransporterData
  const newFarmerCustomer = farmerCustomers.length > 4 ? farmerCustomers.slice(indexOfFirstPost, indexOfLastPost) : farmerCustomers

  let contextValues = {
    availableTransporters,baseUrl,farmersData,
    farmerCustomers, token,  data,  availableBanks, availableCustomers, availableHotels, navigate, relToDel, formik, fetchFarmerInfo, requestAddRelationship, requestDelRel, setRelToDel, relToDel, farmerTransporterData, farmerHotelOwners, farmerBankOwners, farmerTransOwners, handleSendMessage, admins, newBanksData, newHotelsData, newTransportersData, currentPage, postsPerPage, paginate, farmerBanks, farmerHotels, newFarmerCustomer, farmerTransporterData, baseUrl
  }

  return (
    <FarmerContext.Provider value={contextValues}>
      {children}
    </FarmerContext.Provider>
  )
}
export { FarmerProvider }
